import { NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/', label: 'Dashboard', icon: 'ri-dashboard-3-line', activeIcon: 'ri-dashboard-3-fill' },
  { path: '/funnel-analysis', label: 'Funnel Analysis', icon: 'ri-filter-3-line', activeIcon: 'ri-filter-3-fill' },
  { path: '/traffic-sources', label: 'Traffic Sources', icon: 'ri-global-line', activeIcon: 'ri-global-fill' },
  { path: '/daily-performance', label: 'Daily Performance', icon: 'ri-bar-chart-2-line', activeIcon: 'ri-bar-chart-2-fill' },
  { path: '/session-journey', label: 'Session Journey', icon: 'ri-route-line', activeIcon: 'ri-route-fill' },
  { path: '/conversion-insights', label: 'Conversion Insights', icon: 'ri-lightbulb-line', activeIcon: 'ri-lightbulb-fill' },
  { path: '/leads', label: 'Leads', icon: 'ri-file-list-3-line', activeIcon: 'ri-file-list-3-fill' },
];

export default function Sidebar() {
  const location = useLocation();

  return (
    <aside className="fixed left-0 top-0 h-screen w-[220px] bg-[#0a0a0a] border-r border-zinc-800/60 flex flex-col z-50">
      {/* Logo */}
      <div className="flex items-center gap-3 px-5 py-5 border-b border-zinc-800/60">
        <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-amber-500/30 to-amber-600/20 rounded-lg border border-amber-500/30 shrink-0">
          <i className="ri-bar-chart-box-fill text-amber-400 text-base"></i>
        </div>
        <div className="min-w-0">
          <p className="text-white text-sm font-bold leading-tight tracking-tight truncate">Funnel Analiz</p>
          <p className="text-zinc-500 text-[10px] leading-tight truncate">Analytics Console</p>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
        <p className="text-zinc-600 text-[10px] font-semibold uppercase tracking-widest px-3 mb-3">Navigation</p>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 group cursor-pointer ${
                isActive
                  ? 'bg-amber-500/10 text-amber-400 border border-amber-500/20'
                  : 'text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800/50 border border-transparent'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className={`${isActive ? item.activeIcon : item.icon} text-base`}></i>
              </div>
              <span className="truncate">{item.label}</span>
              {isActive && (
                <div className="ml-auto w-1.5 h-1.5 rounded-full bg-amber-400 shrink-0"></div>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="px-4 py-4 border-t border-zinc-800/60">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 flex items-center justify-center rounded-full bg-gradient-to-br from-amber-500/20 to-amber-600/20 border border-amber-500/30 shrink-0">
            <i className="ri-user-line text-amber-400 text-xs"></i>
          </div>
          <div className="min-w-0">
            <p className="text-zinc-300 text-xs font-semibold truncate">Admin</p>
            <p className="text-zinc-600 text-[10px] truncate">analytics@panel.io</p>
          </div>
        </div>
      </div>
    </aside>
  );
}